"use strict";
// @ts-ignore
try {
    self['workbox:core:6.1.5'] && _();
}
catch (e) { }
